/**
 * Browser storage keys used by the tracking library.
 *
 * Every key is declared here once so a rename is a single edit and cannot
 * silently diverge between the writing and the reading side. All keys share the
 * `stn_tr_` prefix, which namespaces this library's entries against the host
 * application's own storage.
 */

/**
 * localStorage key holding the data source cached for an organization.
 */
export const STORAGE_KEY_ORG_DATA_SOURCE = 'stn_tr_org_data_source';

/**
 * localStorage key holding the cached user payload reused across page loads.
 */
export const STORAGE_KEY_USER_DATA = 'stn_tr_user_data';

/**
 * localStorage key holding the timestamp of the last identification.
 */
export const STORAGE_KEY_ID_LAST = 'stn_tr_id_last';

/**
 * localStorage key holding the timestamp at which identification was confirmed.
 */
export const STORAGE_KEY_ID_CONFIRMED = 'stn_tr_id_confirmed';

/**
 * localStorage key holding the uid the user was last identified as.
 */
export const STORAGE_KEY_IDENTIFIED_AS = 'stn_tr_identified_as';

/**
 * localStorage key holding the number of identification attempts made.
 */
export const STORAGE_KEY_ID_ATTEMPTS = 'stn_tr_id_attempts';

/**
 * localStorage key holding the timestamp of the first identification attempt.
 */
export const STORAGE_KEY_ID_FIRST_ATTEMPT = 'stn_tr_id_first_attempt';

/**
 * localStorage key holding the user's groups, indexed by organization.
 */
export const STORAGE_KEY_USER_GROUPS_BY_ORG = 'stn_tr_user_groups_by_org';

/**
 * localStorage key holding the number of consecutive offline attempts.
 */
export const STORAGE_KEY_OFFLINE_ATTEMPTS = 'stn_tr_offline_attempts';

/**
 * localStorage key holding the timestamp at which offline retries were paused.
 */
export const STORAGE_KEY_OFFLINE_PAUSED_AT = 'stn_tr_offline_paused_at';

/**
 * sessionStorage key holding the user currently reported to OpenObserve.
 *
 * Session-scoped rather than persistent: it exists to avoid re-identifying the
 * same user twice within one browser session.
 */
export const SESSION_KEY_OO_CURRENT_USER = 'stn_tr_oo_current_user';

/**
 * Prefix of the sessionStorage entries under which OIDC client libraries store
 * their credentials.
 *
 * A prefix rather than a key: the entry name carries the authority, so callers
 * enumerate sessionStorage and match on it. Owned by the identity provider's
 * client library, not by this one — do not rename it to fit our own scheme.
 */
export const SESSION_KEY_PREFIX_OIDC_USER = 'oidc.user:';
